import React, { memo } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/Button';
export function UrgencySection() {
  return <section className="py-20 px-4 md:px-8 bg-navy-900 text-cream-100" data-id="element-335">
      <div className="max-w-4xl mx-auto text-center" data-id="element-336">
        <span className="text-4xl mb-4 block" data-id="element-337">⏰</span>
        <h2 className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-338">
          SECCIÓN 9 — URGENCIA
        </h2>
        <h3 className="text-3xl md:text-4xl font-serif font-bold mb-8" data-id="element-339">
          "Cada Noche Sin Dormir Tiene un Precio"
        </h3>

        <div className="bg-navy-800 p-8 rounded-2xl border border-red-900/50 mb-10" data-id="element-340">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-341">
            <AlertTriangle className="h-8 w-8 text-gold-500" data-id="element-342" />
            <span className="text-xl font-bold text-gold-400" data-id="element-343">
              No es dramatismo. Es biología.
            </span>
          </div>

          <p className="text-lg mb-6" data-id="element-344">
            Cada noche de sueño fragmentado o insuficiente:
          </p>

          <ul className="text-left max-w-lg mx-auto space-y-4 mb-8" data-id="element-345">
            <li className="flex items-start gap-3" data-id="element-346">
              <span className="text-red-400 font-bold" data-id="element-347">•</span>
              <span data-id="element-348">Eleva el cortisol del día siguiente</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-349">
              <span className="text-red-400 font-bold" data-id="element-350">•</span>
              <span data-id="element-351">Debilita el sistema inmune progresivamente</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-352">
              <span className="text-red-400 font-bold" data-id="element-353">•</span>
              <span data-id="element-354">Afecta la memoria y la concentración</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-355">
              <span className="text-red-400 font-bold" data-id="element-356">•</span>
              <span data-id="element-357">Hace más difícil regular las emociones</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-358">
              <span className="text-red-400 font-bold" data-id="element-359">•</span>
              <span data-id="element-360">Acelera el desgaste hormonal de la menopausia</span>
            </li>
          </ul>

          <p className="text-xl font-serif italic text-cream-200" data-id="element-361">
            No hay razón para esperar. Los templates están listos. Los
            ingredientes cuestan $50 pesos. Tu primera Noche Silenciosa puede
            ser esta noche.
          </p>
        </div>

        <Button className="w-full md:w-auto text-xl px-12" onClick={() => {
        document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }} data-id="element-362">
          SÍ, QUIERO DORMIR ESTA NOCHE
        </Button>
      </div>
    </section>;
}